import React , {useEffect, useRef, useState, useCallback} from 'react';
import Resolution from 'engine/Resolution.js';
import {connect} from 'react-redux';

const RESOLUTION_4 = new Resolution(4, false);
const RESOLUTION_8 = new Resolution(8, false);
const RESOLUTION_16 = new Resolution(16, false);
const RESOLUTION_32 = new Resolution(32, false);

export const RollButtons = ({color, resolution, sequencerEngine, isRolling, engine}) => {
    return (
        <div className="roll-buttons">
          <RollButton
            color={color}
            isSequenceRolling={isRolling && resolution.resolution === 4}
            engine={engine}
            sequencerEngine={sequencerEngine}
            resolution={RESOLUTION_4}/>
          <RollButton
            color={color}
            isSequenceRolling={isRolling && resolution.resolution === 8}
            engine={engine}
            sequencerEngine={sequencerEngine}
            resolution={RESOLUTION_8}/>
          <RollButton
            color={color}
            isSequenceRolling={isRolling && resolution.resolution === 16}
            engine={engine}
            sequencerEngine={sequencerEngine}
            resolution={RESOLUTION_16}/>
          <RollButton
            color={color}
            isSequenceRolling={isRolling && resolution.resolution === 32}
            engine={engine}
            sequencerEngine={sequencerEngine}
            resolution={RESOLUTION_32}/>
        </div>
    );
}

const RollButton = ({color, resolution, sequencerEngine, isSequenceRolling, engine}) => {
    let ref = useRef(undefined);
    const [rolling, setRolling] = useState(false);

    useEffect(() => {
        setRolling(isSequenceRolling);
    }, [isSequenceRolling, setRolling]);

    const onMouseDown = useCallback(() => {
        let map = {
            ...sequencerEngine.idToSequencerEngine,
            "-1": sequencerEngine.samplerTrack
        };
        let _engine = engine || map[Object.keys(map)[0]];
        if (_engine === undefined) {
            return;
        }
        _engine.resolution = resolution;
        _engine.trackRolling = true;
        for (let key in map) {
            if (map[key]) {
                map[key].sequenceRolling = true;
            }
        }
        if (engine) {
            engine.sequenceRolling = true;
        }
        setRolling(true);
    }, [setRolling, engine]);

    const onMouseUp = useCallback(() => {
        let map = {
            ...
                sequencerEngine.idToSequencerEngine,
            "-1": sequencerEngine.samplerTrack
        };
        let _engine = engine || map[Object.keys(map)[0]];
        if (_engine === undefined) {
            return;
        }
        _engine.resolution = resolution;
        for (let key in map) {
            if (map[key]) {
                map[key].sequenceRolling = false;
            }
        }
        _engine.trackRolling = false;
        if (engine) {
            engine.sequenceRolling = false;
        }
        setRolling(false);
    }, [setRolling]);

    let className = "explore-roll-button";
    if (rolling) {
        className += " flash-it rolling";
    }

    return (
        <div
          ref={ref}
          style={{backgroundColor: color}}
          onMouseDown={onMouseDown}
          onMouseUp={onMouseUp}
          onTouchStart={onMouseDown}
          onTouchEnd={onMouseUp}
          onTouchLeave={onMouseUp}
          className={className}>
          1/{resolution.resolution}
        </div>
    );
};

const mapStateToProps = (state, props) => {
    return {
        resolution: state.sequencer.resolution,
        isRolling: state.sequencer.trackRolling && props.sequencerEngine && props.sequencerEngine.isSequenceRolling,
    };
};

export default connect(mapStateToProps, null)(RollButtons);

